import React from "react";
import styles from "./MarktdatenInfoSection.module.scss";
import { changeInitalDisplay } from "../../action/MarktdatenActions";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

function Tabs({ t, changeInitalDisplay, initialDisplay }) {
  return (
    <div className={styles.tabSection}>
      <span
        className={initialDisplay === "table" && styles.isActive}
        onClick={() => {
          changeInitalDisplay("table");
        }}
      >
        {t("TABELLE")}
      </span>
      <span
        className={initialDisplay === "graph" && styles.isActive}
        onClick={() => {
          if (initialDisplay !== "graph") changeInitalDisplay("graph");
        }}
      >
        {t("DIAGRAMM")}
      </span>
    </div>
  );
}

const mapStateToProps = state => ({
  initialDisplay: state.marktdaten.intialDisplay,
});

const mapDispatchToProps = { changeInitalDisplay };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(Tabs));
